import * as theme from "../theme";

import { emailValidation, noSpaces } from "../util/regex";

import { useContext } from "react";
import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import CustomInput from "../components/inputs/CustomInput";
import InputContainer from "../components/inputs/InputContainer";
import Context from "../contexts/data";

const Email = () => {
  const { email, errorMessage, handleUpdateFormValue, navigate } =
    useContext(Context);

  const handleNextStep = () => {
    if (!email) {
      handleUpdateFormValue("errorMessage", "Please enter your email address.");
      return;
    }

    if (!emailValidation.test(email)) {
      handleUpdateFormValue("errorMessage", "Please enter a valid email.");
      return;
    }

    navigate("phone-number", "Email");
  };

  const handleUpdate = ({ target }) => {
    const { value } = target;
    if (noSpaces.test(value)) {
      handleUpdateFormValue("email", value);
    }
  };

  return (
    <Wrapper>
      <HeaderText
        bigger_text={"Almost done. Email?"}
      />
      <InputContainer inputClass={"genericContainer"}>
        <CustomInput
          name="email"
          autoComplete="email" inputMode="email"
          fieldClass="genericInput"
          errorMessage={errorMessage}
          value={email}
          onChange={handleUpdate}
          placeholder={"Email"}
          labelName={"Email"}
        />
      </InputContainer>
      <ErrorMessage />
      <Button onClick={handleNextStep} />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  @media (max-width: ${theme.mobile}) {
    margin-bottom: 16px;
  }
`;

export default Email;
